module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1041-369b0ba416954c944b3e483c8b9f5fd7.png";